import { AzureAD, AuthenticationState } from "react-aad-msal";

export { AuthenticationState };
export const OktaIDP = AzureAD;
